
import React, { useState, useEffect } from "react";
import { FaPlus, FaEdit, FaTrash, FaUpload } from "react-icons/fa";
import CreateStudentModal from "./CreateStudentModal";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import { saveAs } from "file-saver";

const Student = ({ admin }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const classData = location.state?.classData;

  const [showStudentModal, setShowStudentModal] = useState(false);
  const [students, setStudents] = useState([]);
  const [editStudent, setEditStudent] = useState(null);
  const [showLeaderboard, setShowLeaderboard] = useState(false);
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [selectedExamId, setSelectedExamId] = useState(null);
      const [searchTerm, setSearchTerm] = useState('');

  const [visibleCount, setVisibleCount] = useState(20);
const [loading, setLoading] = useState(false);
const [loadingMore, setLoadingMore] = useState(false);

const [activeView, setActiveView] = useState("students"); 

    const filteredData = students.filter(itm =>
        Object.values(itm).some(val =>
            String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );



  const fetchStudents = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `https://api.scannscore.com/student/${classData.id}`
      );
      setStudents(res.data);
    } catch (err) {
      console.error("Error fetching students:", err);
    } finally {
    setLoading(false);
  }
  };

  useEffect(() => {
    fetchStudents();
  }, []);



useEffect(() => {
  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const docHeight = document.documentElement.scrollHeight;

    // when user reaches bottom (threshold 100px)
    if (scrollTop + windowHeight >= docHeight - 100) {
      loadMore();
    }
  };

  window.addEventListener("scroll", handleScroll);

  return () => window.removeEventListener("scroll", handleScroll);
}, [filteredData, visibleCount]);


const loadMore = () => {
  if (loadingMore) return;
  if (visibleCount >= filteredData.length) return;

  setLoadingMore(true);

  setTimeout(() => {
    setVisibleCount((prev) => prev + 20);
    setLoadingMore(false);
  }, 300); 
};
 useEffect(() => {
  setVisibleCount(20);
}, [searchTerm]);



const visibleData = filteredData.slice(0, visibleCount);

  const handleDelete = async (id) => {
  const result = await Swal.fire({
    title: "Are you sure?",
    text: "You want to delete this student!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#3085d6",
    confirmButtonText: "Yes, delete it!",
  });

  if (result.isConfirmed) {
    try {
      const response = await axios.delete(
        `https://api.scannscore.com/student/${id}`
      );

      if (response.status === 200) {
        setStudents((prev) => prev.filter((stu) => stu.id !== id));

        toast.success("Student deleted successfully");
      }

    } catch (err) {
      console.error("Error deleting student:", err);
      toast.error("Delete failed");
    }
  }
};
 
  const handleEdit = (student) => {
    setEditStudent(student);
    setShowStudentModal(true);

  };

  const handleBulkUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);
    formData.append("class_id", classData.id);

    try {
      const response = await axios.post(
        "https://api.scannscore.com/upload-bulk-excel-data",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      toast.success("Students uploaded successfully ");

      if (response.data?.students) {
        setStudents((prev) => [...prev, ...response.data.students]);
      } else {
        setTimeout(fetchStudents, 500);
      }
    } catch (error) {
      console.error("Bulk upload error:", error);
      toast.error("Bulk upload failed ");
    }
  };

  const handleNavigateQuestions = () => {
    navigate("/admin/question-bank", { state: { classData } });
  };

  const handleLeaderboard = async () => {
    try {
      setSelectedExamId(classData.id);
      setShowLeaderboard(true);

      const res = await axios.get(
        `https://api.scannscore.com/leaderboard-class-wise/${classData.id}`
      );

      setLeaderboardData(res.data);
      setActiveView("leaderboard");
    } catch (err) {
      console.error(err);
    }
  };

  const aggregatedLeaderboard = () => {
    if (!leaderboardData || leaderboardData.length === 0) return [];

    const studentMap = {};

    leaderboardData.forEach((item) => {
      if (!studentMap[item.student_id]) {
        studentMap[item.student_id] = {
          student_id: item.student_id,
          student_name: item.student_name,
          student_roll_no: item.student_roll_no,
          totalScore: 0,
        };
      }

      studentMap[item.student_id].totalScore += item.score;
    });

    return Object.values(studentMap).sort(
      (a, b) => b.totalScore - a.totalScore
    );
  };

  const exportToExcel = () => {
    const data = aggregatedLeaderboard().map((student, index) => ({
      Rank: index + 1,
      Name: student.student_name,
      RollNo: student.student_roll_no,
      TotalScore: student.totalScore,
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Leaderboard");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(fileData, "Leaderboard.xlsx");
  };

  

  return (
    <div className="container-fluid p-3" style={{ minHeight: "100vh" }}>
      
  
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-4">
        <h2 className="mb-3 mb-md-0">Students</h2>

        <div className="d-flex justify-content-end gap-2 flex-wrap">
          {admin.role === "admin" && (
            <>
              <input
                type="file"
                accept=".xlsx,.xls,.csv"
                id="bulkUpload"
                style={{ display: "none" }}
                onChange={handleBulkUpload}
              />

              <button
                className="btn btn-success"
                onClick={() =>
                  document.getElementById("bulkUpload").click()
                }
              >
                <FaUpload className="me-2" />
                Bulk Upload
              </button>
            </>
          )}

          {(admin.role === "admin" || admin.exam === 1 || admin.role =='teacher' || admin.student == 1) && (
            <button
              className="btn btn-primary"
              onClick={() => {
                setEditStudent(null);
                setShowStudentModal(true);
              }}
            >
              <FaPlus className="me-2" />
              New Student
            </button>
          )}
        </div>
      </div>

  
      <div className="mb-3 d-flex gap-2">
        <button className="btn btn-primary">Students</button>
        <button
          className="btn btn-outline-primary"
          onClick={handleNavigateQuestions}
        >
          Exams
        </button>
        <button className="btn btn-warning" onClick={handleLeaderboard}>
          Leader Board
        </button>
      </div>

         <div className="col-12 col-md-4 mb-3">
                            <input
                                type="text"
                                className="form-control border-info "
                                placeholder="Search by name,roll no..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>


{loading && (
  <div className="text-center my-3">
    <div className="spinner-border text-primary" role="status"></div>
    <div>Loading students...</div>
  </div>
)}


{activeView === "students" && (
  filteredData.length === 0 ? (
        <div className="text-center text-muted mt-5">
          No students found.
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped align-middle text-center">
            <thead className="table-light">
              <tr>
                <th>Name</th>
                <th>Class</th>
                <th>Enrollment No</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {visibleData.map((stu, idx) => (
                <tr key={stu.id || idx}>
                  <td>{stu.name}</td>
                  <td>{stu.class_name}</td>
                  <td>{stu.roll_no}</td>
                  <td>{stu.email || "-"}</td>
                  <td>{stu.phone || "-"}</td>

                  <td className="d-flex justify-content-center gap-2">
                    {admin.role === "admin" || admin.student === 1 || admin.role =='teacher' || admin.student == 1  ? (
                      <button
                        className="btn btn-sm btn-warning"
                        onClick={() => handleEdit(stu)}
                      >
                        <FaEdit />
                      </button>
                    ) : (
                      "-"
                    )}

                    {admin.role === "admin" && (
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => handleDelete(stu.id)}
                      >
                        <FaTrash />
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )
)}
    
    


{activeView === "leaderboard" && (
  <div className="mt-4">
 {showLeaderboard && (
        <div className="mt-4">
          <h4 className="mb-3">Class Leaderboard</h4>

          <table className="table table-bordered">
            <thead className="table-dark">
              <tr>
                <th>Rank</th>
                <th>Student Name</th>
                <th>Enrollment No.</th>
                <th>Total Score</th>
              </tr>
            </thead>

            <tbody>
              {aggregatedLeaderboard().length > 0 ? (
                aggregatedLeaderboard().map((student, index) => (
                  <tr key={student.student_id}>
                    <td>{index + 1}</td>
                    <td>{student.student_name}</td>
                    <td>{student.student_roll_no}</td>
                    <td>{student.totalScore}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="d-flex gap-2 mt-3">

             {admin.role === "admin" && ( 
                   <button className="btn btn-success" onClick={exportToExcel}>
              Export Excel
            </button>
             )}
           

            <button
              className="btn btn-danger"
           onClick={() => {
    setShowLeaderboard(false);
    setActiveView("students");
  }}
            >
              Back To Students
            </button>
          </div>
        </div>
      )}
    </div>
)}

     

      
      {showStudentModal && (
        <CreateStudentModal
          student={editStudent}
          classData={classData}
          onClose={() => {
            setShowStudentModal(false);
            fetchStudents();

            toast.success(
              editStudent
                ? "Student updated successfully "
                : "Student added successfully "
            );
          }}
        />
      )}

 
      <ToastContainer position="top-center" autoClose={2000} theme="colored" />
    </div>
  );
};

export default Student;

